/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useMemo, useCallback, useContext,
} from 'react';
import { Box } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import languagify from 'utils/languagify';
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import AppContext from '../../AppContext';

import useStyles from './styles';

const FilterLanguage = () => {
  const { qlikApp } = useContext(AppContext);

  const classes = useStyles();

  const qFilter = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qInfo: { qType: 'languageFilter' },
      qListObjectDef: {
        qDef: {
          qFieldDefs: ['#LANGUAGE'],
        },
        qInitialDataFetch: [{ qWidth: 1, qHeight: 1000 }],
        qShowAlternatives: true,
      },
    },
  });

  const options = useMemo(() => {
    if (!qFilter.layout) return [];
    return qFilter.layout.qListObject.qDataPages[0].qMatrix.map((row) => ({
      qElemNumber: row[0].qElemNumber,
      qState: row[0].qState,
      qText: row[0].qText,
    }));
  }, [qFilter]);

  const handleSelection = useCallback((qElemNumber) => {
    if (!qFilter.model) return;

    window.lang = qElemNumber;
    qFilter.model.selectListObjectValues('/qListObjectDef', [qElemNumber], false);
  }, [qFilter.model]);

  return (
    <Box className={classes.translationBox}>
      <LanguageIcon fontSize="small" />
      {
        options.map((row) => (
          <div onClick={() => handleSelection(row.qElemNumber)} className={row.qState === 'S' ? classes.selected : classes.notSelected} key={row.qElemNumber}>{languagify(row.qText)}</div>
        ))
      }
    </Box>
  );
};

export default FilterLanguage;
